<template>
    <!-- 数字生活服务  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'number',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-4.png",
        }
    },
    computed: {
        title() {
            return this.$t('number.title');
        },
        subtitle() {
            return this.$t('number.subtitle');
        },
        description() {
            return this.$t('number.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }
}
</script>